import { render } from "./PurchasesFileUpload.vue?vue&type=template&id=978f1434"
import script from "./PurchasesFileUpload.vue?vue&type=script&lang=js"
export * from "./PurchasesFileUpload.vue?vue&type=script&lang=js"

import "./PurchasesFileUpload.vue?vue&type=style&index=0&id=978f1434&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__